module.exports = __webpack_public_path__ + "static/media/main idea.7ae98fa9.mp3";